





















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { declination } from '@/services/text-service';
import { ModulePresetModel } from 'water-rest/src/model/messaging/ModulePresetModel';
import { NotificationDto } from 'water-rest/src/model/messaging/NotificationDto';

@Component({})
export default class NotificationReadConfirmModal extends Vue {
  @Prop() messages!: NotificationDto[] | null;
  @Prop({ default: false }) all!: boolean;
  @Prop() moduleList!: ModulePresetModel[];
  @Prop() onConfirm!: () => void;
  @Prop() onClose!: () => void;

  declination!: (number: number, words: string[]) => string;

  get title(): string {
    return this.all ?
      'Пометить все оповещения как просмотренные?' :
      'Пометить оповещение как просмотренное?';
  }

  get count(): string {
    const count = this.messages?.length || 0;
    return `${count} уведомлен${declination(count, ['ие', 'ия', 'ий'])}`;
  }

  get messageSingle(): string {
    return (Array.isArray(this.messages) && this.messages[0]) ?
      (this.messages[0].title || this.messages[0].message || '—') :
      '—';
  }

  get moduleName(): string {
    if (this.all) {
      return '—';
    }
    if (
      this.moduleList === null ||
      !Array.isArray(this.messages) ||
      this.messages.length < 1 ||
      !this.messages[0].systemName
    ) {
      return '«Наименование не указано»';
    }
    const found = this.moduleList.find(item => {
      return this.messages !== null && item.senderCodes.includes(this.messages[0].systemName);
    });
    if (!found) {
      return '«Наименование не указано»';
    }
    return `«${found.senderName}»`;
  }

  get text(): string {
    if (this.all) {
      return '';
    }
    if (
      !Array.isArray(this.messages) ||
      this.messages.length < 1 ||
      !this.messages[0].title
    ) {
      return '«Наименование не указано»';
    }
    return this.messages[0].title ? ` «${this.messages[0].title}»` : '';
  }
}
